export default "__VITE_ASSET__DIIk$ab8__"